<template>
  <a-modal
    :visible="visible"
    :title="id ? $t('modal.editTitle') : $t('modal.createTitle')"
    :destroy-on-close="true"
    :mask-closable="false"
    :closable="false"
    :width="'40%'"
    @cancel="handleCancel()"
  >
    <template slot="footer">
      <a-button key="cancel" @click="handleCancel">
        {{ $t('modal.cancel') }}
      </a-button>
      <a-button key="submit" type="primary" :disabled="loading" :loading="loading" @click="handleSubmit">
        {{ id ? $t('modal.update') : $t('modal.create') }}
      </a-button>
    </template>
    <a-spin :spinning="loading">
      <div class="spin-content setting-modal">
        <a-form :form="form" @submit="handleSubmit">
          <a-row>
            <a-col :md="24">
              <a-form-item :label="$t('brandManager.column.name')">
                <a-input
                  v-decorator="[
                    'name',
                    {
                      initialValue: data ? data.name : '',
                      rules: [{ required: true, message: $t('brandManager.validations.nameRequired') }]
                    }
                  ]"
                  maxlength="255"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :md="24">
              <a-form-item :label="$t('brandManager.column.description')">
                <a-textarea
                  v-decorator="[
                    'description',
                    {
                      initialValue: data ? data.description: ''
                    }
                  ]"
                  :rows="5"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :md="24">
              <a-form-item :label="$t('brandManager.column.icon')">
                <div class="clearfix">
                  <a-upload
                    accept="image/*"
                    list-type="picture-card"
                    :file-list="fileList"
                    :custom-request="customRequest"
                    @preview="handlePreview"
                    @change="handleChange"
                  >
                    <div v-if="fileList.length < 1">
                      <a-icon type="plus" />
                      <div class="ant-upload-text">
                        Upload
                      </div>
                    </div>
                  </a-upload>
                  <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancelPreview">
                    <img alt="example" style="width: 100%" :src="previewImage">
                  </a-modal>
                </div>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
import {
  StoreBrand as ApiStoreBrand,
  ShowBrand as ApiShowBrand,
  UpdateBrand as ApiUpdateBrand,
  UploadImage as ApiUploadImage
} from '@/api/brands';

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export default {
  name: 'BrandModal',
  data() {
    return {
      visible: false,
      form: this.$form.createForm(this),
      id: null,
      data: null,
      previewVisible: false,
      previewImage: '',
      fileList: [],
      loading: false
    };
  },
  methods: {
    getBrand() {
      this.loading = true;
      ApiShowBrand({ id: this.id })
        .then((response) => {
          this.data = response.data;
          this.fileList = [];
          if (response.data.icon) {
            this.fileList = [...this.fileList, { uid: response.data.icon.uid, status: 'done', url: `${response.data.base_url}${response.data.icon.url}` }];
          } 
          this.loading = false;
        })
        .catch(() => { this.loading = false; });
    },
    showModal(id = null) {
      this.visible = true;
      this.id = id;
      this.clearData();
      if (id) {
        this.getBrand();
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields({ force: true }, (err, values) => {
        if (!err) {
          const apiName = this.id ? ApiUpdateBrand : ApiStoreBrand;
          if (this.id) {
            values.id = this.id;
          }
          let icons = [];
          this.fileList.forEach(item => {
            icons = [...icons, { uid: item.uid, url: item.url }];
          });
          values.icon = icons[0];
          this.loading = true;
          apiName(values)
            .then(() => {
              this.loading = false;
              this.visible = false;
              this.$notification.success({ message: this.$t(`modal.successMessage.${this.id ? 'updateSuccess' : 'createSuccess'}`) });
              this.$emit('updateBrandSuccess');
            })
            .catch((error) => {
              const { message } = error.response.data;
              // Show error message
              this.$error({
                title: this.$t('modal.failModal.title'),
                content: message,
                okText: this.$t('modal.failModal.close')
              });
              this.loading = false;
            });
        }
      });
    },
    handleCancel() {
      this.visible = false;
    },
    clearData() {
      this.form.resetFields();
    },
    handleCancelPreview() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    customRequest({ file }) {
      const formData = new FormData();
      formData.append('images[0]', file);
      this.loading = true;
      ApiUploadImage(formData)
        .then((response) => {
          this.loading = false;
          this.fileList.map(item => {
            if (item.uid === file.uid) {
              item.status = 'done';
              item.url = response[0];
            }
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleChange({ fileList }) {
      this.fileList = fileList;
    }
  }
};
</script>

<style lang="scss">
    .setting-modal {
        .ant-form-item {
            margin: 0 0 15px !important;
        }
        .ant-form-item-label {
            line-height: 25px !important;
        }
    }
</style>
